<template>
  <div class="pagination-controls">
    <button 
      @click="goToPage(1)" 
      :disabled="currentPage === 1"
      class="pagination-button"
    >
      &laquo;
    </button>
    <button 
      @click="goToPage(currentPage - 1)" 
      :disabled="currentPage === 1"
      class="pagination-button"
    >
      &lsaquo;
    </button>
    
    <button 
      v-for="page in visiblePages" 
      :key="page"
      @click="goToPage(page)"
      :disabled="page === currentPage"
      :class="{ active: page === currentPage }"
      class="pagination-button"
    >
      {{ page }}
    </button>
    
    <button 
      @click="goToPage(currentPage + 1)" 
      :disabled="currentPage === totalPages"
      class="pagination-button"
    >
      &rsaquo;
    </button>
    <button 
      @click="goToPage(totalPages)" 
      :disabled="currentPage === totalPages"
      class="pagination-button"
    >
      &raquo;
    </button>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    maxVisibleButtons: {
      type: Number,
      default: 5
    }
  },
  computed: {
    visiblePages() {
      const range = [];
      const half = Math.floor(this.maxVisibleButtons / 2);
      let start = Math.max(1, this.currentPage - half);
      let end = Math.min(this.totalPages, start + this.maxVisibleButtons - 1);
      
      // Adjust if we're at the end
      if (end - start + 1 < this.maxVisibleButtons) {
        start = Math.max(1, end - this.maxVisibleButtons + 1);
      }
      
      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      
      return range;
    }
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.$emit('page-changed', page);
      }
    }
  }
}
</script>
<style scoped>
.pagination-controls {
  display: flex;
  justify-content: center;
  margin: 20px 0;
  margin-left: 0px;
  gap: 5px;
  width: 600px;
}

.pagination-button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination-button:hover:not(:disabled) {
  background-color: #f0f0f0;
}

.pagination-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.pagination-button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}
</style>